import * as AuthModule from 'Modules/AuthModule';
import { Auth } from '../EnumTypes/ActionEnumTypes';

import { toast } from 'react-toastify';
import { SVG } from 'Components';
import { SVG_TYPE } from 'Shared/enums';

export const success = () => ({
  type: Auth.ACTIVATE_USER_SUCCESS,
});

const failure = () => ({
  type: Auth.ACTIVATE_USER_FAILURE,
});

const activateUser = (data) => async (dispatch) => {
  const id = toast.loading('Trwa aktywacja konta...');
  try {
    await AuthModule.Connector.activateUser(data);
    dispatch(success());
    toast.update(id, {
      render: 'Pomyślnie aktywowano konto',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
      icon: <SVG variant={SVG_TYPE.CIRCLE_GREEN} type={SVG_TYPE.CHECKED} />,
    });
    return true;
  } catch (err) {
    dispatch(failure());
    toast.update(id, {
      render: 'Nie udało się aktywować konta',
      type: toast.TYPE.ERROR,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
      icon: <SVG variant={SVG_TYPE.WARNING} type={SVG_TYPE.CHECKED} />,
    });
    return false;
  }
};

export default activateUser;
